<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">姓名</label>
            <em class="weui-form-preview__value">{{form.ve_name}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">手机</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{mobileNum || form.ve_mobile}}
              <a href="javascript:;" class="iconfont icon-eye" @click="requestMobileNum"></a>
              <call-mobile :mobile="mobileNum"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">邮箱</label>
            <span class="weui-form-preview__value">{{form.ve_email}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">组织</label>
            <span class="weui-form-preview__value">{{form.ve_orgname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">公司名称</label>
            <span class="weui-form-preview__value">{{form.ve_corp_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">所属行业</label>
            <span class="weui-form-preview__value">{{form.ve_corp_industry}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">地址</label>
            <span
              class="weui-form-preview__value"
              :class="{ 'weui-form-preview__value-icon': !!form.ve_address }"
            >
              {{form.ve_address}}
              <router-link
                v-if="form.ve_address"
                class="iconfont icon-map"
                :to="'/map/baidu?keywords=' + form.ve_address"
              ></router-link>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/document/virtual_employee_edit?id='+form.id"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="f_remove">删除</a>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [form],
  components: {
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/document/virtual_org_emp",
      mobileNum: ''
    };
  },
  methods: {
    /**
     *   重写删除人员后的路由跳转
     */
    f_delete(callback, id) {
        var me = this, main = me.form.main || me.form;
        id = id || main[me.idField];
        me.$loading({
            url: me.baseUrl + '/delete/' + id,
            method: 'POST'
        }).then(function (res) {
            if (res.success) {
                me.$weui.toast("删除成功", 2000);
                if (callback && typeof callback === 'function') {
                    callback.call(me);
                } else {
                    me.$router.back()
                }
            } else {
                me.$weui.topTips("删除失败: " + res.message, 3000);
            }
        }).catch(function () {
            me.$weui.topTips("删除失败", 3000);
        });
    },
    requestMobileNum() {
      var me = this
      if(me.mobileNum) {
        me.mobileNum = ''
      }
      else {
        me.$loading({
            url: "/api/document/virtual_org_emp/read_mobile/" + me.$route.params.id,
        }).then(function (res) {
            if (res.success) {
              me.mobileNum = res.data
            } else {
                me.$weui.topTips(res.message, 3000);
            }
        }).catch(function () {
            me.$weui.topTips("获取电话号码失败", 3000);
        });
      }
    },
  },
}
</script>